import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Row } from 'reactstrap';
import { useTranslation } from '../../../../translations';
import { Fetcher, useFetcher } from '../../../../utils';
import { CreateProduct } from '../createProduct';

interface Props {
  readonly categoryId: number;
  readonly onToggle: () => void;
}

export const CategoryCreateProduct: FC<Props> = ({ categoryId, onToggle }) => {
  const { ts } = useTranslation();
  const history = useHistory();
  const onSuccess = useCallback(
    ({ id }: { id?: number }) => {
      if (!id) {
        return;
      }

      history.push(history.location.pathname.replace(`category/${categoryId}`, `${id}`));
    },
    [categoryId, history],
  );

  const categoryFetch = useFetcher(async () => {
    return await api.getProductCategoryById(categoryId);
  }, [categoryId]);

  if (!categoryFetch.success) {
    return <Fetcher result={categoryFetch} />;
  }

  return (
    <>
      <div>
        <Button color="secondary" onClick={onToggle} outline>
          {ts('back_to_products')}
        </Button>
      </div>
      <hr />
      <div>
        <Row className="justify-content-center" id="createProductForm">
          <CreateProduct category={categoryFetch.data} onSuccess={onSuccess} />
        </Row>
      </div>
    </>
  );
};
